import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../context/useAppContext';
import { Dropdown } from '@weezevent/nacre';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

export function ModifyTemplateAction({ objects: selectedRates }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();
    const history = useHistory();

    if (selectedRates.length !== 1) {
        return null;
    }

    if (!selectedRates[0].rate_template) {
        return null;
    }

    return (
        <Dropdown.Item onClick={() => history.push(`/ticket/O${organization.pk}/rates/${selectedRates[0].rate_template.uuid}`)}>{t('ticket.rates.modifyTemplate')}</Dropdown.Item>
    );
}

ModifyTemplateAction.propTypes = {
    objects: PropTypes.array //required
};
